import { Component, Input } from '@angular/core'

@Component({
  selector: 'skeleton-preloader-list-component',
  templateUrl: './skeleton.preloader.list.component.html',
  styleUrls: ['./skeleton.preloader.list.component.scss']
})
export class SkeletonPreloaderListComponent {
  @Input() entities: any[]
}
